export enum FormTypes {
  AddOnes,
  Customer,
  Address
}
